// 仪器管理路由
import Layout from '@/layout'

const instrumentRoute = [
  {
    path: "/instrument-management",
    component: Layout,
    redirect: "/instrument-management/instrument-list",
    name: "instrumentManagement",
    alwaysShow: true, // will always show the root menu
    meta: {
      title: '仪器管理',
      icon: 'huaxueyongpin',
      roles: ['ROLE_STAFF']
    },
    children: [
      {
        path: "instrument-list",
        component: () => import("@/views/instrumentManagement/instrumentList"),
        name: "instrumentList",
        meta: {
          title: '仪器列表',
          icon: 'yiqi'
        }
      },
      {
        path: "add-instrument",
        component: () => import("@/views/instrumentManagement/add/index"),
        name: "addInstrument",
        meta: {
          title: '添加仪器',
          icon: 'huaxueping'
        }
      },

      {
        path: "edit-instrument/:id",
        name: "editInstrument",
        component: () => import("@/views/instrumentManagement/add/index.vue"),
        meta: {
          title: '编辑仪器',
          icon: 'huaxueping'
        },
        hidden: true
      },
      {
        path: "view-instrument/:id",
        name: "viewInstrument",
        component: () => import("@/views/instrumentManagement/add/index.vue"),
        meta: {
          title: '查看仪器',
          icon: 'huaxueping'
        },
        hidden: true
      },
      {
        path: "maintenance-record",
        component: () => import("@/views/instrumentManagement/add/maintenanceRecord.vue"),
        name: "maintenanceRecord",
        meta: {
          title: '维护保养记录',
          icon: 'cz-jl'
        }
      },
      {
        path: 'instrument-calibration',
        component: () => import('@/views/process/instrumentCalibration/index'),
        name: 'instrumentCalibration',
        meta: {
          title: '仪器校准验收【申请】',
          icon: 'yiqi'
        }
      },
      {
        path: "instrument-center",
        component: () => import("@/views/taskCenter/instrumentCenter/index"),
        name: "instrumentCenter",
        meta: {
          title: "仪器校准验收【审批】",
          icon: "check-result",
        },
      },
      {
        path: "add-verification-record",
        component: () => import("@/views/process/instrumentVerification/index"),
        name: "verificationRecord",
        meta: {
          title: '仪器期间核查【申请】',
          icon: 'shouye'
        },
      },
      {
        path: "instrument-verification",
        component: () => import("@/views/taskCenter/instrumentVerification/index"),
        name: "InstrumentVerificationIndex",
        meta: {
          title: "仪器期间核查【审核】",
          icon: "check-result",
          noCache: true
        }
      },
      {
        path: "add-maintenance-record/:id",
        component: () => import("@/views/instrumentManagement/add/addMaintenanceRecord"),
        name: "addMaintenanceRecord",
        meta: {
          title: '添加维护保养记录',
          icon: 'cz-jl'
        },
        hidden: true
      },
      {
        path: "calibration-record",
        component: () => import("@/views/instrumentManagement/add/calibrationRecord.vue"),
        name: "calibrationRecord",
        meta: {
          title: '校准检定记录',
          icon: 'icon-test-record'
        },
        hidden: true
      },
      {
        path: "verification-record",
        component: () => import("@/views/instrumentManagement/add/verificationRecord.vue"),
        name: "verificationRecordList",
        meta: {
          title: '期间核查记录',
          icon: 'shouye'
        },
        hidden:true
      },
      {
        path: "operating-procedures",
        component: () => import("@/views/instrumentManagement/add/operatingProcedures.vue"),
        name: "operatingProcedures",
        meta: {
          title: '操作规程',
          icon: 'biaozhunguanli'
        },
        hidden:true
      },
      {
        path: "used-record",
        component: () => import("@/views/instrumentManagement/add/usedRecord.vue"),
        name: "usedRecord",
        meta: {
          title: '使用记录',
          icon: 'xiansuojilu'
        },
        hidden:true
      },
      {
        path: "batch-operating-procedures",
        component: () => import("@/views/instrumentManagement/add/batchOperatingProcedures.vue"),
        name: "BatchOperatingProcedures",
        meta: {
          title: '添加操作规程',
          icon: 'biaozhunguanli'
        },
        hidden:true
      },
      {
        path: "view-instrument-verification/:id",
        component: () => import("@/views/process/instrumentVerification/index"),
        name: "ViewInstrumentVerificationProcess",
        meta: {
          title: "查看-仪器期间核查审批",
          icon: "yiqi",
          noCache: true
        },
      },
     {
        path: "approval-instrument-verification/:id",
        component: () => import("@/views/process/instrumentVerification/index"),
        name: "ApprovalInstrumentVerificationProcess",
        meta: {
          title: "审批-仪器期间核查",
          icon: "yiqi",
          noCache: true
        },
      },
      {
        path: "view-instrument-calibration",
        component: () => import("@/views/process/instrumentCalibration/index"),
        name: "viewInstrumentCalibration",
        meta: {
          title: "查看-校准检定验收",
          icon: "yiqi",
          noCache: true
        },
      },
      {
        path: "approval-instrument-calibration",
        component: () => import("@/views/process/instrumentCalibration/index"),
        name: "approvalInstrumentCalibration",
        meta: {
          title: "审批-校准检定验收",
          icon: "yiqi",
          noCache: true
        },
      },
    ]
  }
]
export default  instrumentRoute




// WEBPACK FOOTER //
// ./src/router/modules/instrument.js